__turbopack_context__.v({
  "alignCenter": "R6GqHW_alignCenter",
  "alignCenterDirectionColumn": "R6GqHW_alignCenterDirectionColumn",
  "alignCenterDirectionRow": "R6GqHW_alignCenterDirectionRow",
  "centerBox": "R6GqHW_centerBox",
  "verticallyCentered": "R6GqHW_verticallyCentered",
});
